/* Swiper init for the ORCA testimonials slider. Same shape as the product
   carousel's, plus the two arrows the desktop design puts in the header. */
(() => {
  const init = (root) => {
    root.querySelectorAll('.testimonials__slider').forEach((el) => {
      if (el.swiper) return;
      const section = el.closest('.testimonials');
      // the gap is declared in CSS as `column-gap` (which has no effect on the
      // Swiper container itself) purely so it resolves to pixels here
      const gap = () => parseFloat(getComputedStyle(el).columnGap) || 0;
      const swiper = new Swiper(el, {
        slidesPerView: 'auto',
        spaceBetween: gap(),
        watchOverflow: true,
        navigation: {
          prevEl: section.querySelector('.testimonials__arrow--prev'),
          nextEl: section.querySelector('.testimonials__arrow--next'),
        },
      });
      window.addEventListener('resize', () => {
        swiper.params.spaceBetween = gap();
        swiper.update();
      });
    });
  };

  const start = () => init(document);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
